import { chakra } from '@chakra-ui/react';

export const Svg = chakra('svg');
